import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CareLinkFieldLabel from './CareLinkFieldLabel';

const textToLines = (value) => {
  if (!value || !String(value).trim()) {
    return [];
  }
  return String(value)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
};

const linesToText = (lines) => lines.filter((line) => String(line).trim()).join('\n');

/**
 * Stores multiline info as newline-separated text (compatible with backend TEXT fields).
 * UI: add one line at a time for cleaner public reading.
 */
const CareLinkLineListField = ({
  id,
  label,
  help,
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [draft, setDraft] = useState('');
  const lines = useMemo(() => textToLines(value), [value]);

  const addLine = () => {
    const next = draft.trim();
    if (!next || disabled) {
      return;
    }
    onChange(linesToText([...lines, next]));
    setDraft('');
  };

  const removeLine = (index) => {
    if (disabled) {
      return;
    }
    const nextLines = lines.filter((_, i) => i !== index);
    onChange(linesToText(nextLines));
  };

  return (
    <div className="form-group carelink-line-list-field">
      <CareLinkFieldLabel htmlFor={id} label={label} help={help} />

      {lines.length > 0 && (
        <ul className="carelink-line-list">
          {lines.map((line, index) => (
            <li key={`${id}-${index}`}>
              <span>{line}</span>
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={() => removeLine(index)}
                disabled={disabled}
                title={t('common.delete')}
              >
                <i className="fa fa-trash"></i>
              </button>
            </li>
          ))}
        </ul>
      )}

      <div className="carelink-line-list-add">
        <input
          id={id}
          type="text"
          className="form-control"
          value={draft}
          disabled={disabled}
          placeholder={placeholder || t('carelink.lineList.placeholder')}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addLine();
            }
          }}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={addLine}
          disabled={disabled || !draft.trim()}
        >
          <i className="fa fa-plus"></i> {t('carelink.lineList.add')}
        </button>
      </div>
    </div>
  );
};

export default CareLinkLineListField;
